module.exports = __webpack_public_path__ + "static/media/opengraph-report.d7c4bd65.png";